import { Routes, Route } from "react-router-dom";
import LoginPage from "./LoginPage";
import PageNotFound from "./otherPages/PageNotFound";
import AdminDashboard from "./pages/adminPages/AdminDashboard";

const Router = () => {
  return (
    // <UserAuthContextProvider>
      <Routes>
        <Route path="/" element={<LoginPage />} />

        <Route path="/login" element={<LoginPage />} />

        <Route path="/404" element={<PageNotFound />} />
        <Route path="/admin-dashboard" element={<AdminDashboard />} />

        {/* <Route element={<ProtectedRoute />}>
          <Route path="/my-nfc-card" element={<MyNFCCard />} />
        </Route> */}
        
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    // </UserAuthContextProvider>
  );
};

export default Router;
